export const ADDRESS_SELECTED = 'ADDRESS_SELECTED';

export const addressSelected = payload => dispatch =>
  dispatch({
    type: ADDRESS_SELECTED,
    payload,
  });
